import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Row, Table } from 'reactstrap';
import Butt from './Butt';
import Logo from './Logo';
import API from '../API';
import { Apify } from '../Apify';
import I18N from '../I18N';
import { A, BlessLink, R } from '../routes';
import ChangeArrow from './ChangeArrow';
import { connect } from 'react-redux';
import { TradeButton } from './Trade';
import { T, TraksConsumer } from '../traks';
import { RangedChart, LargeChartInner } from '../c/Chart';
import { classes } from '../CUtil';
import Follow from './Follow';
import LogoAndInfo from './LogoAndInfo';
import { SortMagic } from './Tables';
import { default_currency } from '../Site';
import { array2set, isPortfolioExplore, setCommodityName } from '../misc';
import { ordered_and_available_market_ids } from '../markets';

const G = (props) => props.children;

function ExploreMarketsButtons(props) {
	if (props.smartphone) {
		return <A href="/explore"><Button className="ad_find_buy_btn w-100 py-2 px-3"><b><T>Find &amp; Buy equities</T></b></Button></A>;
	}

	const market_buttons = {
		"DK_STOCK": <span key="dk" className="p-2"><A href="/explore-cph"><T><Button className="ad_explore_market_button mt-2"><img alt="DK" className="ad_25x25px" src="/gfx/denmark-icon-0.svg"/><span className="pl-2">Danish</span></Button></T></A></span>,
		"SE_STOCK": <span key="se" className="p-2"><A href="/explore-sto"><T><Button className="ad_explore_market_button mt-2"><img alt="SE" className="ad_25x25px" src="/gfx/sweden-icon-0.svg"/><span className="pl-2">Swedish</span></Button></T></A></span>,
		"FI_STOCK": <span key="fi" className="p-2"><A href="/explore-hel"><T><Button className="ad_explore_market_button mt-2"><img alt="FI" className="ad_25x25px" src="/gfx/finland-icon-0.svg"/><span className="pl-2">Finnish</span></Button></T></A></span>,
		"IS_STOCK": <span key="is" className="p-2"><A href="/explore-ice"><T><Button className="ad_explore_market_button mt-2"><img alt="IS" className="ad_25x25px" src="/gfx/iceland-icon-0.svg"/><span className="pl-2">Icelandic</span></Button></T></A></span>,
		"DE_STOCK": <span key="de" className="p-2"><A href="/explore-xetra"><T><Button className="ad_explore_market_button mt-2"><img alt="DE" className="ad_25x25px" src="/gfx/germany-icon-0.svg"/><span className="pl-2">German</span></Button></T></A></span>,
		"AT_STOCK": <span key="at" className="p-2"><A href="/explore-vie"><T><Button className="ad_explore_market_button mt-2"><img alt="AT" className="ad_25x25px" src="/gfx/austria-icon-0.svg"/><span className="pl-2">Austrian</span></Button></T></A></span>,
		"FOREX":    <span key="bank" className="p-2"><A href="/explore-bank"><T><Button className="ad_explore_market_button mt-2"><img alt="Bank" className="ad_25x25px" src="/gfx/currencies-0.svg"/><span className="pl-2">Currencies</span></Button></T></A></span>,
		"US_STOCK": <span key="us" className="p-2"><A href="/explore-us"><T><Button className="ad_explore_market_button mt-2"><img alt="USA" className="ad_25x25px" src="/gfx/usa-icon-0.svg"/><span className="pl-2">American</span></Button></T></A></span>,
		"COMMODITIES": <span key="comm" className="p-2"><A href="/explore-commodities"><T><Button className="ad_explore_market_button mt-2"><img alt="Commodities" className="ad_25x25px" src="/gfx/commodities-icon-0.svg"/><span className="pl-2">Commodities</span></Button></T></A></span>,
		"CRYPTOCURRENCIES": <span key="crypto" className="p-2"><A href="/explore-crypto"><T><Button className="ad_explore_market_button mt-2"><img alt="Crypto" className="ad_25x25px" src="/gfx/crypto-icon-0.svg"/><span className="pl-2">Crypto</span></Button></T></A></span>,
        "ETFS": <span key="etf" className="p-2"><A href="/explore-etfs"><T><Button className="ad_explore_market_button mt-2"><img alt="EFTs" className="ad_25x25px" src="/gfx/eft-icon-0.svg"/><span className="pl-2">ETFs</span></Button></T></A></span>,
        "INDEXES": <span key="index" className="p-2"><A href="/explore-indexes"><T><Button className="ad_explore_market_button mt-2"><img alt="Indexes" className="ad_25x25px" src="/gfx/indexes-icon-0.svg"/><span className="pl-2">Indexes</span></Button></T></A></span>,
        "FUNDS": <span key="funds-and-bonds" className="p-2"><A href="/explore-funds"><T><Button className="ad_explore_market_button mt-2"><img alt="Funds-and-bonds" className="ad_25x25px" src="/gfx/funds-and-bonds-icon-0.svg"/><span className="pl-2">Funds and Bonds</span></Button></T></A></span>
	};

	const market_set = array2set(props.markets || [])

	const buttons = [];
	const wrappedButtons = [];

	let passedDK = false;

	for (const market_id of ordered_and_available_market_ids) {
		if (!market_set[market_id] || !market_buttons[market_id]) continue;

		if (market_id === "DK_STOCK") {
			buttons.push(market_buttons[market_id]);
			passedDK = true;
			continue;
		}

		if (passedDK) {
			wrappedButtons.push(market_buttons[market_id]);
		}
	}

	// Add wrapper div if there are any wrapped buttons
	if (wrappedButtons.length > 0) {
		buttons.push(
			<div key="other-markets" className="mt-2">
				<div className="d-flex flex-wrap justify-content-center align-items-center fw-bold">
					<span className="txt-color-white">Andre:</span>
					{wrappedButtons}
				</div>
			</div>
		);
	}

	return buttons;
}

function LargePortfolioChart(props) {
	return <RangedChart range_in="state" type="portfolio" inner={LargeChartInner} {...props}/>
}

function LargeGameChart(props) {
	return <RangedChart range_in="state" type="game" inner={LargeChartInner} {...props}/>
}

var PortfolioExplorerRow = (props) => {
	const asset = props.asset;
	const href = R.href("/ticker/:exchange/:ticker", {exchange: asset.Exchange, ticker: asset.Ticker});
	const mk_interval_td = (interval, td_classes) => {
		var inner;
		if (asset.Change && asset.Change[interval]) {
			const change = asset.Change[interval];
			inner = <ChangeArrow pct={change.RelativeChange*100} suffix="%"/>;
		} else {
			inner = <ChangeArrow svg_only pct={0} suffix="%"/>;
		}
		return <td className={td_classes}>{inner}</td>
	};

    let name = asset.Name;
    if (asset.Exchange === 'NYSE-ARCA' || asset.Exchange === 'NASDAQ') {
        name = setCommodityName(asset.Ticker, asset.Name);
    }

	return (
		<tr className={props.tr_classes}>
			<td className="pl-3 mr-0 py-md-2 align-middle table-cell-min">
				<span className="text-overflow-dynamic-container">
					<span className="text-overflow-dynamic-ellipsis">
						<A className='txt-color-white' href={href}>{name}</A>
					</span>
				</span>
			</td>
			<td className="align-middle py-md-2">
				{I18N.floatval_unit(asset.StockRate, 2, asset.StockCurrency)}
			</td>
			{mk_interval_td("1d", "align-middle py-md-2 fw-bold")}
			{mk_interval_td("7d", "d-none d-md-table-cell align-middle py-md-2 fw-bold")}
			{mk_interval_td("1m", "d-none d-md-table-cell align-middle py-md-2 fw-bold")}
			{mk_interval_td("3m", "d-none d-md-table-cell align-middle py-md-2 fw-bold")}
			{mk_interval_td("1y", "d-none d-md-table-cell align-middle py-md-2 fw-bold")}
		</tr>
	)
}

function CalculateBetaValue(totalValue, stockValue, betaValue) {
    if (betaValue !== 0) {
        return ((stockValue / totalValue) * betaValue)
    }

    return 0;
}

function PortfolioRow(props) {
	const ass = props.asset;
	const game_currency = props.game_currency;
	var total_delta_pct = ass.ValueGrowth*100;
	var total_delta_money = ass.Value - (ass.Value / (1 + ass.ValueGrowth));
	const quote_now = I18N.floatval_unit((ass.Value / ass.Quantity), 2, game_currency);
	const quote_bought = I18N.floatval_unit(((ass.Value - total_delta_money) / ass.Quantity), 2, game_currency);

	var action_elements;
	if (props.enable_actions) {
		if (props.is_game) {
			action_elements = (
				<TradeButton
					exchange={ass.Exchange}
					ticker={ass.Ticker}
					portfolio_id={props.portfolio_id}
					refresh={props.refresh}
					portfolio={true}
                    isFlagged={props.isFlagged}
				/>
			);
		} else {
			const remove = () => {
				API.post("/a/delete_stock_from_portfolio", {portfolio_id: props.portfolio_id, exchange: ass.Exchange, ticker: ass.Ticker}, (response) => {
					props.refresh();
				});
			};
			action_elements = <Butt className="ad_btn_danger ad_btn_sm" onClick={remove}><T>Remove</T></Butt>;
		}
	}

	const quantity = I18N.floatval(ass.Quantity, ass.NDecimals);
	const total_change_percent = <ChangeArrow pct={total_delta_pct} suffix="%"/>
	const total_suffix = " (" + props.render_static(I18N.floatval(total_delta_pct, 2)) + "%)";
	const total_change_money = <ChangeArrow currency_unit={game_currency} pct={total_delta_money} suffix={total_suffix}/>
	var today_change_percent = <span className="ad_growth_zero">&mdash;&nbsp;%</span>;
	/* XXX: Too much info? var today_change = <span className="ad_growth_zero">&mdash; kr. (&mdash;%)</span>;*/

	if (ass.Change && ass.Change["1d"]) {
		today_change_percent = <ChangeArrow pct={ass.Change["1d"].RelativeChange*100} suffix="%"/>
	}

    

	const href = R.href("/ticker/:exchange/:ticker", {exchange: ass.Exchange, ticker: ass.Ticker});
	return (
		<tr className={props.tr_classes}>
			{ass.Quantity && !props.hide_values && <th scope="row">{quantity}</th>}
			<td>
				<span className="text-overflow-dynamic-container">
					<span>
						<A class="txt-color-white" href={href}>{ass.Name}</A>
					</span>
				</span>
			</td>
			{ass.Value && !props.hide_values && <td>{I18N.floatval_unit(ass.Value, 2, game_currency)}</td>}
            {props.is_beta_value_active === true && props.show_beta === true && <td>{ass.BetaValue ? I18N.floatval_unit(ass.BetaValue, 4) : '-'}</td>}
			{ass.Value && !props.hide_values && <td>{quote_now}&nbsp;({quote_bought})</td>}
			<td className="fw-bold">{ass.Value && !props.hide_values ? total_change_money : total_change_percent}</td>
			{props.show_today && <td>{today_change_percent}</td>}
			{ass.Value && props.show_actions && <td>{action_elements}</td>}
		</tr>
	)
}

const PortfolioImpl = (props) => {
    const [isFlagged, setIsFlagged] = useState(false)

	const portfolio = props.portfolio;

	let is_god = false;

	if (props.me && props.me.IsGod) {
		is_god = props.me.IsGod;
    }

	const is_brief = portfolio.IsBrief;
	const is_full = !is_brief;
	const is_game = !!portfolio.Portfolio.Game;
    const hide_values = props.hideValues || false;
    let is_beta_value_active = false
	const right_now = (new Date()).getTime();
	var game_run_time;

	var rows = [];
	var game_currency_asset = null;
	let game_currency_ticker = default_currency;
	var bankroll;
	var total_orig = 0;
	var total_now = 0;
	var show_bankroll;
    var show_beta;
	var best_chart_range = "3m";

    useEffect(() => {
        const fetchFlagged = () => {
            API.get("/a/is_user_flagged", {}, (response, status) => {
                if (status >= 200 && status < 300) {
                    setIsFlagged(response)
                }
            })
        }

        // run once immediately
        fetchFlagged();

         // then repeat every 60s
        const interval = setInterval(fetchFlagged, 60000);

        // cleanup on unmount
        return () => clearInterval(interval);
    }, [])

	if(is_game) {
        is_beta_value_active = portfolio.Portfolio.Game.BetaValue;

		game_run_time = right_now - portfolio.Portfolio.Game.StartTime * 1000;
		if(game_run_time < 14*60*60*24*1000) {
			best_chart_range = "7d";
		}
	}

	if (props.show_bankroll === undefined) {
		show_bankroll = true;
	} else {
		show_bankroll = Boolean(props.ad_show_bankroll);
	}

    if (props.show_beta === undefined && is_beta_value_active) {
        show_beta = true;
    } else {
        show_beta = false;
    }

	const refresh_after_action = () => {
		props.ctl.reload();
	}

	let portfolio_is_mine = !!props.is_owner;
	const portfolio_is_explorers = portfolio.IsExplorePortfolio;

	if(!portfolio_is_mine) show_bankroll = false;
    if(!portfolio_is_mine) show_beta = false;

	const game_is_ended = portfolio.Portfolio.Game && portfolio.Portfolio.Game.State === "ended";
	const show_today = !game_is_ended;
	const show_trade = !game_is_ended;

	const SM = (() => {
		var columns = {};
		for (const ck of ["1d","7d","1m","3m","1y"]) {
			columns[ck] = {
				key: ((ck) => x => (x.Change[ck] && x.Change[ck].RelativeChange) || 0)(ck),
			};
		}
		return SortMagic(columns);
	})();

    let total_value = 0
    let total_beta = 0
    for (const asset of portfolio.Assets) {
        total_value += asset.Value;
        total_now += asset.Value;
    }

    for (const asset of portfolio.Assets) {
        const beta_value = CalculateBetaValue(total_value, asset.Value, asset.BetaValue)
        total_beta += beta_value;
    }

    for (const asset of portfolio.SellAssets) {
        const beta_value = CalculateBetaValue(total_value, asset.Value, asset.BetaValue)
        total_beta += beta_value;
    }

	var tr_i = 0;
	for (const asset of SM.sort(portfolio.Assets)) {
		var tr_classes = "";
		if (tr_i > 0) { /* No border on first row */
			tr_classes = "ad_game_table_border";
		}
        const beta_value = CalculateBetaValue(total_value, asset.Value, asset.BetaValue)
        
		if (asset.IsGameCurrency) {
			game_currency_asset = asset;
			game_currency_ticker = game_currency_asset.Ticker;
			if (!is_game) total_orig += game_currency_asset.Value;
			continue;
		} else {
			if (!is_game) total_orig += asset.Value / (1 + asset.ValueGrowth);
		}

		if (portfolio_is_explorers && !portfolio_is_mine) {
			rows.push(
				<PortfolioExplorerRow
					key={`${asset.Exchange}:${asset.Ticker}`}
					asset={asset}
					tr_classes={tr_classes}
				/>
			);
		} else {
            if (isFlagged === true) {
                portfolio_is_mine = false;
            } 

			rows.push(
				<PortfolioRow
					render_static={props.render_static}
					key={`${asset.Exchange}:${asset.Ticker}`}
					portfolio_id={portfolio.Portfolio.Id}
					asset={asset}
					is_game={is_game}
					refresh={refresh_after_action}
					enable_actions={portfolio_is_mine}
                    isFlagged={isFlagged}
					show_today={show_today}
					show_actions={!is_game || show_trade}
					tr_classes={tr_classes}
					game_currency={game_currency_ticker}
                    is_beta_value_active={is_beta_value_active}
                    total_value={total_value}
                    show_beta={show_beta}
                    calculated_beta={beta_value}
                    hide_values={hide_values}
				/>
			);
		}
		tr_i++;
	}

	if (is_game) total_orig = portfolio.Portfolio.Game.InitialAmount;
	if (is_brief) total_now = portfolio.Total;

	var total_change = total_now - total_orig;
	var total_change_percent = (total_now / total_orig - 1) * 100;
	var risk_adjusted_return_percent = (total_change_percent !== 0 && total_beta !== 0) ? I18N.floatval(total_change_percent / total_beta, 2) : "-";
	var total_change_suffix = " (" + props.render_static(I18N.floatval(total_change_percent, 2)) + "%)";

	total_change_percent = <ChangeArrow pct={total_change_percent} suffix="%"/>
	total_change = <ChangeArrow currency_unit={game_currency_ticker} pct={total_change} suffix={total_change_suffix}/>

	if(game_currency_asset && show_bankroll) {
		bankroll =
			<Row>
				<Col>
					<div className="bg-color-dark-black ad_game_table_heading pb-3">
						<span className="ad_150pct">
							<b><T>Bankroll</T></b>:&nbsp;<strong className="ad_main_green">{I18N.floatval_unit(game_currency_asset.Value, 2, game_currency_asset.Ticker)}</strong>
						</span>
						{show_beta ? (
							<div className='d-flex flex-column'>
								<span className="pl-2 pl-md-5">
									<b><T>The risk-adjusted return of the portfolio</T></b>:&nbsp;<strong>{risk_adjusted_return_percent === "-" ? "-" : risk_adjusted_return_percent}{risk_adjusted_return_percent !== '-' ? ' %' : null}</strong>
								</span>
								<span className="pl-2 pl-md-5">
									<b><T>The risk score of the portfolio (Beta)</T></b>:&nbsp;<strong>{I18N.floatval_unit(total_beta, 4)}</strong>
								</span>
							</div>
						) : null}
					</div>
				</Col>
			</Row>
	}

	var title;
	if (props.show_title) {
		var owner;
		if (!portfolio_is_mine) {
			owner = portfolio.Portfolio.OwnerScreenName;
		} else if (portfolio.Portfolio.Game) {
			owner = <T>your portfolio</T>;
		}
		if (owner) {
			const isExplorePortfolio = isPortfolioExplore(portfolio.Portfolio.Id); 
			if (isExplorePortfolio) {
				title = <div className="ad_150pct pt-3"><b>{portfolio.Portfolio.Name}</b></div>;
			} else {
				title = <div className="ad_150pct pt-3"><b>{portfolio.Portfolio.Name} &mdash; {owner}</b></div>;
			}
		} else {
			title = <div className="ad_150pct p-4"><b>{portfolio.Portfolio.Name}</b></div>;
		}
	}

	var chartElement;
	var chartPart;

	if (props.include_chart && !portfolio_is_explorers) {
		if(props.portfolio.Portfolio.Game) {
			chartPart = <LargeGameChart range={best_chart_range} game_id={props.portfolio.Portfolio.Game.Id} portfolio_id={props.portfolio.Portfolio.Id}/>;
		} else {
			chartPart = <LargePortfolioChart range={best_chart_range} id={portfolio.Portfolio.Id}/>;
		}

		chartElement = (
			<Row>
				<Col>
					{chartPart}
				</Col>
			</Row>
		);
	}

	var table_head, last_table_row;
	var top_border_class = "";

	if(!props.show_title) {
		top_border_class = " ad_no_border-top";
	}

	if (portfolio_is_explorers && !portfolio_is_mine) {
		table_head = (
			<tr>
				<th className={classes("pl-3 mr-0" + top_border_class)}><T>Security</T></th>
				<th className={top_border_class}><T>Latest</T></th>
				<SM.Th colkey="1d" className={top_border_class}><T>Today</T></SM.Th>
				<SM.Th colkey="7d" className={classes("d-none d-md-table-cell" + top_border_class)}><T>7d</T></SM.Th>
				<SM.Th colkey="1m" className={classes("d-none d-md-table-cell" + top_border_class)}><T>1m</T></SM.Th>
				<SM.Th colkey="3m" className={classes("d-none d-md-table-cell" + top_border_class)}><T>3m</T></SM.Th>
				<SM.Th colkey="1y" className={classes("d-none d-md-table-cell" + top_border_class)}><T>1y</T></SM.Th>
			</tr>
		);
		last_table_row = <tr></tr>;
	} else {
		table_head = (
			<tr>
				{is_full && !hide_values && <th class="text-uppercase font-s"><T>Quantity</T></th>}
				<th class="text-uppercase font-s"><T>Security</T></th>
				{is_full && !hide_values && <th class="text-uppercase font-s"><T>Value</T></th>}
                {is_full && !hide_values && is_beta_value_active && <th class="text-uppercase font-s"><T>Risk Score</T></th>}
				{is_full && !hide_values && <th class="text-uppercase font-s"><T>Quote (Paid)</T></th>}
				<th class="text-uppercase font-s"><T>Change</T></th>
				{show_today && <th class="text-uppercase font-s"><T>Today</T></th>}
				{is_full && show_trade && <th></th>}
			</tr>
		);
	}

	var table_graph_element;

	var no_equities_element;
	if (is_full) {
		no_equities_element = (
					<Col xs="12">
						<div className="bg-color-dark-black ad_game_table_heading">
							<div className="font-weight-bold mb-3"><T>You have no equities</T></div>
						</div>
					</Col>
					);
	} else {
		no_equities_element = (
					<Col xs="12">
						<div className="bg-color-dark-black ad_game_table_heading">
							<div className="font-weight-bold mb-3"><T>You have no equities</T></div>
						</div>
					</Col>
				);
	}

	var previously_traded_element;
	if (props.allow_previously_traded && is_game && portfolio.PreviouslyTraded.length > 0) {
		var stock_elements = portfolio.PreviouslyTraded.map((stock) => {
			const key = stock.Exchange + ":" + stock.Ticker
			const href = R.href("/ticker/:exchange/:ticker", {exchange: stock.Exchange, ticker: stock.Ticker});
			return (
				<BlessLink><Button key={key} href={href} className="text-left ad_prev_trade_button flex-grow-1 m-2">
					<div style={{"minHeight": "60px"}} className="d-flex flex-column justify-content-center">
						<LogoAndInfo exchange={stock.Exchange} ticker={stock.Ticker} name={stock.Name} hasData={true} />
					</div>
				</Button></BlessLink>
			);
		});

		previously_traded_element = (
			<div>
				<h4><T>Equities previously traded in game</T></h4>
				<div className="row justify-content-between p-3 d-flex">
					{stock_elements}
				</div>
			</div>
		);
	}

	if (tr_i === 0) {
		table_graph_element = (
			<G>
				<Row className="">
					{no_equities_element}
				</Row>
				{chartElement}
				{previously_traded_element}
			</G>
		);
	} else {
		table_graph_element = (
			<G>
				<div className="ad_game_box overflow-auto mb-3">
					<Table className="table-borderless bg-color-dark-black txt-color-white ad_game_table mb-0">
						<thead>
							{table_head}
						</thead>
						<tbody>
							{rows}
							{last_table_row}
						</tbody>
					</Table>
				</div>
				{chartElement}
				{!portfolio_is_mine && previously_traded_element}
			</G>
		);

	}

	let FlagPortfolioButton = (props) => {
        const flag = () => {
            if (window.confirm("Are you sure you want to flag this portfolio?")) {
                API.post("/a/flag_portfolio", { portfolio_id: portfolio.Portfolio.Id }, () => {
                    props.ctl.reload();
                });
            }
        };

        const unflag = () => {
            if (window.confirm("Are you sure you want to unflag this portfolio?")) {
                API.post("/a/unflag_portfolio", { portfolio_id: portfolio.Portfolio.Id }, () => {
                    props.ctl.reload();
                });
            }
        }

        return props.is_flagged ? (
            <button className="btn btn-danger btn-sm" onClick={unflag}>
                Unflag Portfolio
            </button>
        ) : (
            <button className="btn btn-danger btn-sm" onClick={flag}>
                Flag Portfolio
            </button>
        );
    };

	FlagPortfolioButton = Apify("/a/is_portfolio_flagged")
    .with_query_from_props(props => ({ portfolio_id: props.portfolio.Portfolio.Id }))
    .with_response_prop('is_flagged')
    .with_ctl_prop()
    .wrap(FlagPortfolioButton);

		return (
		<Container className="m-0 p-0">
			<div className="d-flex justify-content-between">
			{title}
			{props.me && !portfolio_is_mine && !portfolio_is_explorers &&
				<div className="py-3">
					<Follow user_id={portfolio.Portfolio.OwnerUserId}/>
				</div>
			}
			</div>
            {is_god && !portfolio_is_explorers && (
                <div className="py-3">
				    <FlagPortfolioButton {...props}/>
                </div>
			)}
			{bankroll}
			{table_graph_element}
			
		</Container>
	)
}


const PublicPortfolio = Apify("/z/portfolio_assets")
	.with_query_from_props(props => ({portfolio_id: props.portfolio_id, lang: R.get_current_language()}))
	.with_4xx_prop("error")
	.with_response_prop("portfolio")
	.wrap((props) => {
		if (props.error) return null;
		return (
			<React.Fragment>
				<TraksConsumer>
					<PortfolioImpl {...props}/>
				</TraksConsumer>
			</React.Fragment>
		);
	});

var PrivatePortfolio = Apify("/a/my_portfolio_assets")
    .with_query_from_props(props => ({portfolio_id: props.portfolio_id, lang: R.get_current_language()}))
    .with_response_prop("portfolio")
    .with_ctl_prop()
	.wrap((props) => {
		return <TraksConsumer><PortfolioImpl {...props} is_owner={true}/></TraksConsumer>;
	});

const ResolveFirst = Apify("/a/is_portfolio_owner")
	.with_query_from_props(props => ({portfolio_id: props.portfolio_id}))
	.with_response_prop("is_owner")
	.wrap((props) => {
		if (props.is_owner) {
			return <PrivatePortfolio {...props}/>
		} else {
			return <PublicPortfolio {...props}/>
		}
	});

const PortfolioWithResolve = connect(
	(state) => ({me: state.me})
)((props) => {
	if (props.me) {
		return <ResolveFirst {...props}/>
	} else {
		return <PublicPortfolio {...props}/>
	}
});

export {
	PortfolioWithResolve,
	PublicPortfolio,
	PrivatePortfolio,
	ExploreMarketsButtons
}



// WEBPACK FOOTER //
// ./src/c/Portfolio.js